import Service from "lib/models/Service";
import { RoomListRes } from "./models";

export default class ChatService extends Service {
  public async findChatRooms(
    pageSize: number,
    pageNumber: number,
  ): Promise<RoomListRes> {
    try {
      const res = await this.get("/firestore/chat-rooms", {
        page_size: pageSize,
        page_number: pageNumber,
      });
      if (!res) {
        throw res;
      }
      return res;
    } catch (e) {
      throw e;
    }
  }

  public async findChatList(
    roomkey: string,
    pageSize: number,
    pageNumber: number,
  ): Promise<any> {
    try {
      const res = await this.get(`/firestore/chat-rooms/${roomkey}`, {
        page_size: pageSize,
        page_number: pageNumber,
      });
      if (!res) {
        throw res;
      }
      return res;
    } catch (e) {
      throw e;
    }
  }
}
